import { SelectChangeEvent, Select, MenuItem, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FieldType, OptionType } from "../../../services/helpers/types";
import { createMultiSelectTooltip } from "./helper";
import { useTranslation } from "react-i18next";

interface MultiSelectProps {
  field?: FieldType;
  value?: string;
  onChange?: (value: string) => void;
}

const MultiSelect = (props: MultiSelectProps) => {
  const { field, value = "", onChange } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [options, setOptions] = useState<OptionType[]>([]);
  const [selected, setSelected] = useState<string[]>([]);
  const [selectOpen, setSelectOpen] = useState(false);

  useEffect(() => {
    if (value) {
      const currentSelected = value.split("|");
      setSelected(currentSelected);
    } else {
      setSelected([]);
    }
  }, [value]);

  useEffect(() => {
    if (field?.options) {
      setOptions(field.options);
    }
  }, [field, dispatch]);

  const handleSelectChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value;
    const fullValue = typeof value === "string" ? value : value.join("|");
    if (onChange) {
      onChange(fullValue);
    }
  };
  return (
    <div className="dui-multi-select-wrapper">
      <Tooltip
        title={createMultiSelectTooltip(selected, options, t)}
        placement="left-start"
        open={selectOpen}
      >
        <Select
          multiple
          className="dui-multi-select"
          value={selected}
          onChange={handleSelectChange}
          onOpen={() => setSelectOpen(true)}
          onClose={() => setSelectOpen(false)}
        >
          {options.length > 0
            ? options.map((option, index) => (
                <MenuItem
                  key={index}
                  value={option.value}
                  className="dui-select-item"
                >
                  {option.name}
                </MenuItem>
              ))
            : null}
        </Select>
      </Tooltip>
    </div>
  );
};

export default MultiSelect;
